import React, { Fragment, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import MainWrapper from "../../MainWrapper";
import '../../../assets/css/Main.css';
import { Row, Col, Card, Table } from 'react-bootstrap';
import contacticon from '../../../assets/images/contact-icon.png';
import proposalicon from '../../../assets/images/proposal-icon.png';
import ordersicon from '../../../assets/images/orders-icon.png';
import invoiceicon from '../../../assets/images/invoice-icon.png';
import reporticon from '../../../assets/images/report-icon.png';
import { connect } from 'react-redux';
import Loader from "../../layouts/Loader";
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ORDER_USER_REQUEST } from "../../../_utils/constants/Auth";
import { GET_INSUFFICIENT_PRODUCT_REQUEST } from "../../../_utils/constants/Customer";

const Dashboard = ({
  auth: { auth, isAuthenticated },
  customerInfo: { insufficientInventoryData, totalInvCount },
  fetchInsufficientInventory
}) => {

  const [insufficientInventoryDetails, setInsufficientInventoryDetails] = useState([])
  const [page, setPage] = useState(20)
  const [hasMore, setHasMore] = useState(true)
  const [isFetchingMore, setIsFetchingMore] = useState(false)

  useEffect(() => {
    let isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn'))
    if (isAuthenticated && isLoggedIn) {
      toast.success("Login success.")
      localStorage.setItem('isLoggedIn', false)
    }
    if (isAuthenticated) {
      fetchInsufficientInventory(auth, page)
    }
  }, [auth, isAuthenticated])

  useEffect(() => {
    if (insufficientInventoryData && insufficientInventoryData.length > 0) {
      setInsufficientInventoryDetails(prev => {
        const existingJobNos = new Set(prev.map(item => item.jobNo))
        const newUniqueItems = insufficientInventoryData.filter(
          item => !existingJobNos.has(item.jobNo)
        )
        const updatedList = [...prev, ...newUniqueItems]
        if (updatedList.length >= totalInvCount) {
          setHasMore(false)
        }
        setIsFetchingMore(false)
        return updatedList
      })
    }
  }, [insufficientInventoryData, totalInvCount])

  if (!isAuthenticated) return <Navigate to="/login" />

  // handle fetching of more data
  const fetchMoreData = () => {
    if (isFetchingMore || insufficientInventoryDetails.length >= totalInvCount) {
      setHasMore(false)
      return
    }
    const nextPage = page + 10
    setIsFetchingMore(true)
    setPage(nextPage)
    fetchInsufficientInventory(auth, nextPage)
  }

  // handle date formatting
  const handleFormatDate = (installationDate) => {
    const dateObj = new Date(installationDate)
    const month = dateObj.getMonth() + 1
    const day = dateObj.getDate()
    const year = dateObj.getFullYear()
    return `${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}-${year}`
  }

  return (
    <MainWrapper>
      <Fragment>
        <Loader loading={false}>
          <Row className="nav-cards mb-4">
            <Col>
              <Card>
                <Card.Body className="d-flex align-items-center">
                  <div className="info">
                    <h5 className="title mb-0">Contacts</h5>
                    <h1 className="mb-0">500</h1>
                  </div>
                  <Card.Img variant="top" className="icon" src={contacticon} />
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="d-flex align-items-center">
                  <div className="info">
                    <h5 className="title mb-0">Proposals</h5>
                    <h1 className="mb-0">500</h1>
                  </div>
                  <Card.Img variant="top" className="icon" src={proposalicon} />
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="d-flex align-items-center">
                  <div className="info">
                    <h5 className="title mb-0">Orders</h5>
                    <h1 className="mb-0">500</h1>
                  </div>
                  <Card.Img variant="top" className="icon" src={ordersicon} />
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="d-flex align-items-center">
                  <div className="info">
                    <h5 className="title mb-0">Invoices A/R</h5>
                    <h1 className="mb-0">500</h1>
                  </div>
                  <Card.Img variant="top" className="icon" src={invoiceicon} />
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card>
                <Card.Body className="d-flex align-items-center">
                  <div className="info">
                    <h5 className="title mb-0">Reports</h5>
                    <h1 className="mb-0">500</h1>
                  </div>
                  <Card.Img variant="top" className="icon" src={reporticon} />
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <h4 className="title">Insufficient Materials</h4>
          <div className="insufficient-material-table" id="scrollableDiv" style={{ maxHeight: 400, overflow: 'auto' }}>
            <InfiniteScroll
              dataLength={insufficientInventoryDetails.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={
                isFetchingMore ? <h6>Loading more items...</h6> : null
              }
              scrollableTarget="scrollableDiv"
            >
              <Table bordered hover responsive>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Job No</th>
                    <th>Product</th>
                    <th>Insufficient Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {insufficientInventoryDetails.map((data, index) => (
                    <tr key={index}>
                      <td>{handleFormatDate(data.createdOn)}</td>
                      <td>{data.jobNo}</td>
                      <td>{data.productName}</td>
                      <td>{parseFloat(data.insufficientQuantity).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </InfiniteScroll>
          </div>

          <h4 className="title">Job Mail/Alerts</h4>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th></th>
                <th>Type</th>
                <th>Date</th>
                <th>Priority</th>
                <th>Action Required</th>
                <th>From</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>

          <Row>
            <Col md={6}>
              <Card>
                <Card.Body>
                  <h5 className="title">Bank Statment Balance</h5>
                  <Table bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Account</th>
                        <th>Account Name</th>
                        <th>Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>&nbsp;</td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body className="d-flex align-items-center">
                  <h5 className="title">Cash Collected Today</h5>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Loader>
      </Fragment>

    </MainWrapper>
  );
}
const mapStateToProps = ({ auth, customerInfo }) => {
  return {
    auth,
    customerInfo
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleCookie: (data) => dispatch({ type: ORDER_USER_REQUEST, data }),
    fetchInsufficientInventory: (data, paginate) => dispatch({ type: GET_INSUFFICIENT_PRODUCT_REQUEST, data, paginate }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);